var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../../sutl';
import { CalendarEvents } from '../framework/EmulatorCalendarEvents';
import { Directory } from '../framework/EmulatorDirectory';
import { Timeouts } from '../framework/Timeouts';
export class Zoom {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.commandExtractor = {
            terminators: ['\r', '\n'],
        };
        this.sendTerminator = '\r\n';
        this.appVersion = 'unknown';
        this.audioInputVolume = 50;
        this.audioOutputVolume = 50;
        this.calendarEvents = CalendarEvents.create(['zoom']);
        this.callStatus = 'NOT_IN_MEETING';
        this.cameraMute = false;
        this.deviceSystem = 'unknown';
        this.directory = Directory.create(['zoom']);
        this.directPresentationPairingCode = this.generatePairingCode();
        this.directPresentationSharingKey = this.generateSharingKey();
        this.displayVersion = '5.17.9 (3926)';
        this.dispState = 'None';
        this.hideConfSelfVideo = false;
        this.isBlackMagicConnected = true;
        this.isSharingBlackMagic = false;
        this.isSharingCamera = false;
        this.layoutStyle = 'Speaker';
        this.meetingId = '';
        this.meetingPassword = '';
        this.meetingType = 'NONE';
        this.microphoneMute = false;
        this.participantId = this.generateParticipantId();
        this.participantIds = [];
        this.realMeetingId = '';
        this.roomVersion = '5.17.9.3926';
        this.selectedCameraId = Zoom.peripherals.camera.id;
        this.selectedLineInId = Zoom.peripherals.lineIn.id;
        this.selectedLineOutId = Zoom.peripherals.lineOut.id;
        this.timeouts = new Timeouts();
        this.userAvatarUrl = 'img/directory/craigRichardson.jpg';
        this.userId = this.generateUserId();
        this.userIdMax = this.userId + 1;
        this.userIds = {};
        this.userName = `Craig's Office`;
        this.asyncHandlers = [
            {
                regExp: /echo (off|on)/i,
                callback: (match) => {
                    return;
                },
            },
            {
                regExp: /format (json)/i,
                callback: (match) => {
                    return;
                },
            },
            {
                regExp: /^\s*zCommand\s+Bookings\s+List/i,
                callback: (match) => {
                    this.send('zEvent', 'BookingsListResult', this.calendarEvents.map(event => {
                        var _a, _b, _c, _d;
                        const booking = {
                            startTime: new Date(event.start).toISOString(),
                        };
                        if ((_a = event.organizer) === null || _a === void 0 ? void 0 : _a.emailAddress) {
                            booking.creatorEmail = event.organizer.emailAddress;
                        }
                        if ((_b = event.organizer) === null || _b === void 0 ? void 0 : _b.name) {
                            booking.creatorName = event.organizer.name;
                        }
                        if (event.end) {
                            booking.endTime = new Date(event.end).toISOString();
                        }
                        if (event.summary) {
                            booking.meetingName = event.summary;
                        }
                        for (const callMethod of Object.values((_c = event.callMethods) !== null && _c !== void 0 ? _c : {})) {
                            if (callMethod.callType === 'zoom' && callMethod.dialString) {
                                booking.meetingNumber = callMethod.dialString;
                                break;
                            }
                        }
                        if ((_d = event.description) === null || _d === void 0 ? void 0 : _d.content) {
                            booking.summary = event.description.content;
                        }
                        return booking;
                    }));
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+CameraControl\s+Id:\s*(\S+)/i,
                callback: (match) => {
                    this.send('zCommand', 'CameraControl', {});
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+(Disconnect|Leave)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    yield this.callDisconnect();
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Info/i,
                callback: (match) => {
                    this.sendCallInfo(true);
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Invite\s+user:\s*(.+)\s*/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.callStatus !== 'IN_MEETING') {
                        throw Error('call invite only allowed in meeting');
                    }
                    this.send('zCommand', 'InviteCallResult', {});
                    this.addParticipants(match[1].split(/\s*user:\s*/));
                    yield this.timeouts.delay(500);
                    this.sendListParticipants(false);
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+ListParticipants/i,
                callback: (match) => {
                    this.sendListParticipants(true);
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+MuteAll\s+Mute:\s*(on|off)/i,
                callback: (match) => {
                    const mute = match[1] === 'on';
                    for (const id of this.participantIds) {
                        const entry = this.findDirectoryEntry(id);
                        if (entry === undefined)
                            continue;
                        entry.microphoneMute = mute;
                    }
                    this.send('zCommand', 'CallMuteAllResult', {});
                    this.sendListParticipants(false);
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+MuteParticipant\s+Mute:\s*(on|off)\s+Id:\s*(\S+)/i,
                callback: (match) => {
                    const id = parseInt(match[2], 10);
                    let participantId;
                    for (const [pId, uId] of Object.entries(this.userIds)) {
                        if (uId === id) {
                            participantId = pId;
                            break;
                        }
                    }
                    if (participantId === undefined) {
                        this.log.warning('invalid user id');
                        return;
                    }
                    const entry = this.findDirectoryEntry(participantId);
                    if (entry === undefined) {
                        this.log.warning('invalid participant id');
                        return;
                    }
                    if (!this.participantIds.includes(participantId)) {
                        this.log.warning('participant not in meeting');
                        return;
                    }
                    entry.microphoneMute = match[1] === 'on';
                    this.send('zCommand', 'CallMuteParticipantResult', {});
                    this.sendListParticipant(participantId, entry, false);
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+MuteParticipantVideo\s+Mute:\s*(on|off)\s+Id:\s*(\S+)/i,
                callback: (match) => {
                    const id = parseInt(match[2], 10);
                    let participantId;
                    for (const [pId, uId] of Object.entries(this.userIds)) {
                        if (uId === id) {
                            participantId = pId;
                            break;
                        }
                    }
                    if (participantId === undefined) {
                        this.log.warning('invalid user id');
                        return;
                    }
                    const entry = this.findDirectoryEntry(participantId);
                    if (entry === undefined) {
                        this.log.warning('invalid participant id');
                        return;
                    }
                    if (!this.participantIds.includes(participantId)) {
                        this.log.warning('participant not in meeting');
                        return;
                    }
                    entry.cameraMute = match[1] === 'on';
                    this.send('zCommand', 'CallMuteParticipantVideoResult', {});
                    this.sendListParticipant(participantId, entry, false);
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+SetInstructions\s+Show:\s*(\S+)\s+Type:\s*(\S+)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    const show = match[1].toLowerCase();
                    const type = match[2].toLowerCase();
                    if (show === 'on' && type === 'ios') {
                        yield this.setSharingInstructions('IOS');
                    }
                    else if (show === 'on' && type === 'laptop') {
                        yield this.setSharingInstructions('Laptop');
                    }
                    else if (show === 'off' && type === 'none') {
                        yield this.setSharingInstructions('None');
                    }
                    else {
                        this.log.error(`unhandled setInstructions case: show = ${show}, type = ${type}`);
                        return;
                    }
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+ShareCamera\s+id:\s*(\S+)\s+Status:\s*(on|off)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1] === Zoom.peripherals.camera.id) {
                        this.isSharingCamera = match[2].toLowerCase() === 'on';
                        if (this.isSharingCamera) {
                            this.isSharingBlackMagic = false;
                            this.dispState = 'None';
                        }
                        this.send('zCommand', 'ShareCameraResult', {});
                        yield this.timeouts.delay(500);
                        this.sendSharing(false);
                        this.sendCameraShare(false);
                    }
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Sharing\s+Disconnect/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    this.isSharingBlackMagic = false;
                    this.isSharingCamera = false;
                    this.dispState = 'None';
                    this.send('zCommand', 'CallSharingDisconnectResult', {});
                    yield this.timeouts.delay(500);
                    this.sendSharing(false);
                    this.sendCameraShare(false);
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Sharing\s+HDMI\s+Start/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    // Assume we're already in a meeting.
                    this.send('zCommand', 'CallSharingHDMIResult', {});
                    this.meetingType = 'SHARING_LAPTOP';
                    this.isSharingBlackMagic = true;
                    this.isSharingCamera = false;
                    yield this.timeouts.delay(1);
                    this.sendSharing(false);
                    this.sendCameraShare(false);
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Sharing\s+HDMI\s+Stop/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    this.send('zCommand', 'CallSharingHDMIResult', {});
                    this.isSharingBlackMagic = false;
                    yield this.timeouts.delay(500);
                    this.sendCallLayout(false);
                    this.sendSharing(false);
                }),
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Sharing\s+ToNormal/i,
                callback: (match) => {
                    this.meetingType = 'NORMAL';
                    this.send('zCommand', 'CallSharingToggleResult', {});
                },
            },
            {
                regExp: /^\s*zCommand\s+Call\s+Spotlight\s+Id:\s*(\d+)\s+Enable:\s*(on|off)/i,
                callback: (match) => {
                    const enable = match[2].toLowerCase() === 'on';
                    if (enable) {
                        const id = parseInt(match[1], 10);
                        let participantId;
                        for (const [pId, uId] of Object.entries(this.userIds)) {
                            if (uId === id) {
                                participantId = pId;
                                break;
                            }
                        }
                        if (participantId === undefined) {
                            this.log.warning('invalid user id');
                            return;
                        }
                        const entry = this.findDirectoryEntry(participantId);
                        if (entry === undefined) {
                            this.log.warning('invalid participant id');
                            return;
                        }
                        if (!this.participantIds.includes(participantId)) {
                            this.log.warning('participant not in meeting');
                            return;
                        }
                        this.send('zCommand', 'SetSpotlight', {});
                        this.send('zEvent', 'SpotlightStatusNotification', { user_id: id }, false);
                    }
                    else {
                        this.send('zCommand', 'SetSpotlight', {});
                        this.send('zEvent', 'SpotlightStatusNotification', { user_id: -1 }, false);
                    }
                },
            },
            {
                regExp: /^\s*zCommand\s+Dial\s+Join\s+meetingNumber:\s*(\d+)(?:\s+password:\s*(.+))?/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (match[2]) {
                        // accept any password
                        yield this.dialJoin({ meetingId: match[1], passcode: match[2] });
                    }
                    else {
                        this.microphoneMute = false;
                        this.cameraMute = false;
                        this.layoutStyle = 'Speaker';
                        this.callStatus = 'CONNECTING_MEETING';
                        this.send('zCommand', 'DialJoinResult', {});
                        this.sendCallStatus(false);
                        this.sendMeetingNeedsPassword(false);
                        this.sendSharing(false);
                        this.sendCallLayout(true);
                        this.sendCallLayoutStyle(false);
                        this.callStatus = 'NOT_IN_MEETING';
                        this.resetParticipants();
                        this.sendCallStatus(false);
                        this.sendCallDisconnect(false);
                        this.sendSharing(false);
                    }
                }),
            },
            {
                regExp: /^\s*zCommand\s+Dial\s+PhoneCallOut\s+Number:\s*(\S+)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.sipCallId !== undefined || this.callStatus !== 'NOT_IN_MEETING') {
                        this.log.warning(`can't place sip call while call is active`);
                        return;
                    }
                    this.sipCallId = match[1];
                    this.send('zCommand', 'DialPhoneCallOut', {});
                    yield this.timeouts.delay(1000);
                    if (this.sipCallId !== undefined) {
                        this.send('zEvent', 'PhoneCallStatus', {
                            callID: this.sipCallId,
                            isIncomimngCall: false,
                            peerUri: this.sipCallId,
                            status: 'PhoneCallStatus_InCall',
                        }, false);
                    }
                }),
            },
            {
                regExp: /^\s*zCommand\s+Dial\s+PhoneHangUp\s+CallId:\s*(\S+)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.sipCallId === undefined) {
                        this.log.error('sip call not active');
                        return;
                    }
                    if (match[1] !== this.sipCallId) {
                        this.log.error('invalid call id');
                        return;
                    }
                    this.sipCallId = undefined;
                    this.send('zCommand', 'DialPhoneHangUp', {});
                    yield this.timeouts.delay(1000);
                    if (this.sipCallId === undefined) {
                        this.send('zEvent', 'PhoneCallTerminated', { callID: match[1] }, false);
                    }
                }),
            },
            {
                regExp: /^\s*zCommand\s+Dial\s+Sharing\s+Duration:\s*(\d+)\s+DisplayState:\s*(\S+)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    const displayState = match[2].toLowerCase();
                    let dispState = 'None';
                    if (displayState === 'ios') {
                        dispState = 'IOS';
                    }
                    else if (displayState === 'laptop') {
                        dispState = 'Laptop';
                    }
                    else if (displayState === 'none') {
                        dispState = 'None';
                    }
                    else {
                        this.log.error(`invalid display state: ${displayState}`);
                        return;
                    }
                    yield this.dialSharing(dispState);
                }),
            },
            {
                regExp: /^\s*zCommand\s+Dial\s+StartPmi\s+Duration:\s*(\d+)/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    yield this.dialStartPmi();
                }),
            },
            {
                regExp: /^\s*zCommand\s+Invite\s+Duration:\s+\d+\s+user:\s*(.+)\s*/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.callStatus !== 'NOT_IN_MEETING') {
                        throw Error('call invite not allowed in meeting');
                    }
                    this.addParticipants(match[1].split(/\s*user:\s*/));
                    yield this.dialStartPmi('InviteResult');
                }),
            },
            {
                regExp: /^\s*zCommand\s+Phonebook\s+List\s+Offset:\s*(\d+)\s+Limit:\s*(\d+)/i,
                callback: (match) => {
                    const offset = parseInt(match[1], 10);
                    const limit = parseInt(match[2], 10);
                    const contacts = [];
                    const n = Math.min(offset + limit, this.directory.length);
                    for (let i = offset; i < n; i++) {
                        const contact = this.makeContact(this.directory[i]);
                        if (contact)
                            contacts.push(contact);
                    }
                    this.send('zCommand', 'PhonebookListResult', { Contacts: contacts });
                },
            },
            {
                regExp: /^\s*zCommand\s+Phonebook\s+Subscribe\s+Offset:\s*\d+\s+Limit:\s*\d+/i,
                callback: (match) => {
                    this.send('zCommand', 'PhonebookSubscribeResult');
                },
            },
            {
                regExp: /^\s*zCommand\s+SendSIPDTMF\s+callId:\s*(\S+)\s+key:\s*(\S)/i,
                callback: (match) => {
                    this.send('zCommand', 'SendSIPDTMF', {});
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Audio\s+Input\s+selectedId:\s*(\S+)/i,
                callback: (match) => {
                    const p = this.findPeripheral('lineIn', match[1]);
                    if (!p) {
                        this.log.error(`invalid audio input id: ${match[1]}`);
                        return;
                    }
                    this.selectedLineInId = p.id;
                    this.send('zConfiguration', 'Audio', { Input: { selectedId: p.id } });
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Audio\s+Input\s+volume(?::\s*(\d+))?/i,
                callback: (match) => {
                    if (match[1])
                        this.audioInputVolume = this.parseNumber(match[1]);
                    const data = { Input: { volume: this.audioInputVolume } };
                    this.send('zConfiguration', 'Audio', data);
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Audio\s+Output\s+selectedId:\s*(\S+)/i,
                callback: (match) => {
                    const p = this.findPeripheral('lineOut', match[1]);
                    if (!p) {
                        this.log.error(`invalid audio output id: ${match[1]}`);
                        return;
                    }
                    this.selectedLineOutId = p.id;
                    this.send('zConfiguration', 'Audio', { Output: { selectedId: p.id } });
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Audio\s+Output\s+volume(?::\s*(\d+))?/i,
                callback: (match) => {
                    if (match[1])
                        this.audioOutputVolume = this.parseNumber(match[1]);
                    const data = { Output: { volume: this.audioOutputVolume } };
                    this.send('zConfiguration', 'Audio', data);
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Call\s+Camera\s+Mute(?::\s*(on|off))?/i,
                callback: (match) => {
                    if (match[1]) {
                        if (this.callStatus === 'IN_MEETING') {
                            this.send('zConfiguration', 'Configuration', {});
                            this.cameraMute = match[1].toLowerCase() === 'on';
                        }
                        else {
                            this.send('zConfiguration', 'Call', undefined, true, {
                                message: 'Result reason: "Not in meeting"',
                                state: 'Error',
                            });
                            return;
                        }
                    }
                    this.sendCameraMute();
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Call\s+Layout\s+Style(?::\s*(\S+))?/i,
                callback: (match) => {
                    if (match[1]) {
                        const style = match[1].charAt(0).toUpperCase() + match[1].slice(1).toLowerCase();
                        if (!['Speaker', 'Strip'].includes(style))
                            return;
                        this.layoutStyle = style;
                    }
                    this.sendCallLayoutStyle(false);
                    this.send('zConfiguration', 'Configuration', {});
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Call\s+Microphone\s+Mute(?::\s*(on|off))?/i,
                callback: (match) => {
                    if (match[1]) {
                        if (this.callStatus === 'IN_MEETING') {
                            this.microphoneMute = match[1].toLowerCase() === 'on';
                            this.send('zConfiguration', 'Configuration', {});
                            this.sendListParticipants(false);
                        }
                        else {
                            this.send('zConfiguration', 'Call', undefined, true, {
                                message: 'Result reason: "Not in meeting"',
                                state: 'Error',
                            });
                            return;
                        }
                    }
                    else {
                        this.sendMicrophoneMute();
                    }
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Client\s+appVersion(?::\s*(.+))?/i,
                callback: (match) => {
                    if (match[1]) {
                        this.appVersion = match[1];
                        this.send('zConfiguration', 'Configuration');
                    }
                    else {
                        this.send('zConfiguration', 'Client', { appVersion: this.appVersion });
                    }
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Client\s+deviceSystem(?::\s*(.+))?/i,
                callback: (match) => {
                    if (match[1]) {
                        this.deviceSystem = match[1];
                        this.send('zConfiguration', 'Configuration');
                    }
                    else {
                        this.send('zConfiguration', 'Client', { deviceSystem: this.deviceSystem });
                    }
                },
            },
            {
                regExp: /^\s*zConfiguration\s+SIPCall\s+Microphone\s+Mute(?::\s*(on|off))?/i,
                callback: (match) => {
                    if (match[1]) {
                        if (this.sipCallId !== undefined) {
                            this.microphoneMute = match[1].toLowerCase() === 'on';
                            this.send('zConfiguration', 'Configuration', {});
                        }
                        else {
                            this.send('zConfiguration', 'SIPCall', undefined, true, {
                                message: 'Result reason: "Not in meeting"',
                                state: 'Error',
                            });
                            return;
                        }
                    }
                    else {
                        this.send('zConfiguration', 'SIPCall', {
                            Microphone: { Mute: this.microphoneMute },
                        });
                    }
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Video\s+Camera\s+selectedId:\s*(\S+)/i,
                callback: (match) => {
                    const p = this.findPeripheral('camera', match[1]);
                    if (!p) {
                        this.log.error(`invalid camera id: ${match[1]}`);
                        return;
                    }
                    this.selectedCameraId = p.id;
                    this.send('zConfiguration', 'Video', { Camera: { selectedId: p.id } });
                },
            },
            {
                regExp: /^\s*zConfiguration\s+Video\s+hide_conf_self_video(?::\s*(on|off))?/i,
                callback: (match) => {
                    let sync = true;
                    if (match[1]) {
                        this.hideConfSelfVideo = match[1].toLowerCase() === 'on';
                        this.send('zConfiguration', 'Configuration');
                        sync = false;
                    }
                    this.send('zConfiguration', 'Video', {
                        hide_conf_self_video: this.hideConfSelfVideo,
                    }, sync);
                },
            },
            {
                regExp: /^\s*zStatus\s+Audio\s+Input\s+Line/i,
                callback: (match) => {
                    const resp = Object.values(Zoom.peripherals)
                        .filter(p => p.type === 'lineIn')
                        .map(p => {
                        return {
                            Alias: p.alias,
                            Name: p.name,
                            Selected: p.id === this.selectedLineInId,
                            combinedDevice: false,
                            id: p.id,
                            manuallySelected: p.id === this.selectedLineInId,
                            numberOfCombinedDevices: 0,
                            ptzComId: -1,
                        };
                    });
                    this.send('zStatus', 'Audio Input Line', resp);
                },
            },
            {
                regExp: /^\s*zStatus\s+Audio\s+Output\s+Line/i,
                callback: (match) => {
                    const resp = Object.values(Zoom.peripherals)
                        .filter(p => p.type === 'lineOut')
                        .map(p => {
                        return {
                            Alias: p.alias,
                            Name: p.name,
                            Selected: p.id === this.selectedLineOutId,
                            combinedDevice: false,
                            id: p.id,
                            manuallySelected: p.id === this.selectedLineOutId,
                            numberOfCombinedDevices: 0,
                            ptzComId: -1,
                        };
                    });
                    this.send('zStatus', 'Audio Output Line', resp);
                },
            },
            {
                regExp: /^\s*zStatus\s+Call\s+Layout\s*$/i,
                callback: (match) => {
                    this.sendCallLayout();
                },
            },
            {
                regExp: /^\s*zStatus\s+Call\s+Status/i,
                callback: (match) => {
                    this.sendCallStatus();
                },
            },
            {
                regExp: /^\s*zStatus\s+CameraShare/i,
                callback: (match) => {
                    this.sendCameraShare();
                },
            },
            {
                regExp: /^\s*zStatus\s+SystemUnit/i,
                callback: (match) => {
                    this.send('zStatus', 'SystemUnit', {
                        email: 'info@aveosystems.com',
                        login_type: 'work_email',
                        meeting_number: '1234567890',
                        platform: 'Windows,10.0',
                        room_info: {
                            account_email: 'info@aveosystems.com',
                            display_version: this.displayVersion,
                            is_auto_answer_enabed: false,
                            is_auto_answer_selected: false,
                            room_name: 'Aveo Systems',
                        },
                        room_version: this.roomVersion,
                    });
                },
            },
            {
                regExp: /^\s*zStatus\s+Video\s+Camera\s+Line/i,
                callback: (match) => {
                    const resp = Object.values(Zoom.peripherals)
                        .filter(p => p.type === 'camera')
                        .map(p => {
                        return {
                            Alias: p.alias,
                            Name: p.name,
                            Selected: p.id === this.selectedCameraId,
                            combinedDevice: false,
                            id: p.id,
                            manuallySelected: p.id === this.selectedCameraId,
                            numberOfCombinedDevices: 0,
                            ptzComId: -1,
                        };
                    });
                    this.send('zStatus', 'Video Camera Line', resp);
                },
            },
            {
                regExp: /^\s*zStatus\s+Capabilities/i,
                callback: (match) => {
                    this.send('zStatus', 'Capabilities', {
                        aec_Setting_Stored_In_ZR: true,
                        can_Dtmf_For_Invite_By_Phone: true,
                        can_Mute_On_Entry: true,
                        can_Ringing_In_Pstn_Call: true,
                        can_Switch_To_Specific_Camera: true,
                        is_Airhost_Disabled: false,
                        pstn_Call_In_Local_resentation: true,
                        support_Claim_Host: true,
                        support_Out_Room_Display: true,
                        support_Pin_And_Spotlight: true,
                        supports_Audio_Checkup: true,
                        supports_Check_in: true,
                        supports_Cloud_PBX: true,
                        supports_Encrypted_Connection: true,
                        supports_Expel_User_Permanently: true,
                        supports_H323_DTMF: true,
                        supports_Hdmi_Cec_Control: true,
                        supports_Highly_Reverberant_Room: false,
                        supports_Loading_Contacts_Dynamically: true,
                        supports_Loading_Participants_Dynamically: true,
                        supports_Mic_Record_Test: true,
                        supports_Multi_Share: true,
                        supports_ShareCamera: true,
                        supports_Share_For_Floating_And_Content_Only: true,
                        supports_Sip_Call_out: true,
                        supports_Software_Audio_Processing: true,
                        supports_Web_Settings_Push: true,
                    });
                },
            },
            {
                regExp: /\s*zStatus\s+NumberOfScreens/i,
                callback: (match) => {
                    this.send('zStatus', 'NumberOfScreens', {
                        NumberOfCECScreens: 0,
                        NumberOfScreens: 1,
                    });
                },
            },
            {
                regExp: /\s*zStatus Sharing/i,
                callback: (match) => {
                    this.sendSharing(true);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.isBlackMagicConnected = false;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (videoInput.code === 'hdmi') {
                this.isBlackMagicConnected = true;
            }
        }
        this.isSharingBlackMagic = false;
        this.dispState = 'None';
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
    addSimulatedParticipants() {
        let i = 0;
        const interval = this.timeouts.setInterval(() => {
            if (this.callStatus !== 'IN_MEETING' || i >= Directory.numParticipants) {
                interval.clear();
                return;
            }
            const entry = this.directory[i];
            for (const c of Object.values(entry.contacts)) {
                if (c.type === 'zoom') {
                    this.addParticipants([c.number]);
                    this.sendListParticipant(c.number, entry, false);
                    break;
                }
            }
            i++;
        }, 1);
    }
    addParticipants(userIds) {
        for (const userId of userIds) {
            if (this.participantIds.includes(userId))
                continue;
            const entry = this.findDirectoryEntry(userId);
            if (entry) {
                entry.prevPresence = entry.presence;
                entry.presence = 'busy';
                this.sendContact(entry);
                this.participantIds.push(userId);
            }
        }
    }
    callDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.callStatus === 'IN_MEETING') {
                this.microphoneMute = false;
                this.cameraMute = false;
                this.callStatus = 'NOT_IN_MEETING';
                this.meetingType = 'NONE';
                this.dispState = 'None';
                this.isSharingBlackMagic = false;
                this.isSharingCamera = false;
                this.resetParticipants();
                this.send('zCommand', 'CallDisconnectResult', {});
                yield this.timeouts.delay(500); // required for driver
                this.sendSharing(false);
                this.sendCameraShare(false);
                this.sendCallStatus(false);
                this.sendCallDisconnect(false);
            }
            else {
                const status = {
                    message: 'Result reason: "Must be in meeting to disconnect',
                    state: 'Error',
                };
                this.send('zCommand', 'CallDisconnectResult', {}, true, status);
            }
        });
    }
    convertPresence(presence) {
        switch (presence) {
            case 'away':
                return 'PRESENCE_AWAY';
            case 'busy':
                return 'PRESENCE_BUSY';
            case 'dnd':
                return 'PRESENCE_DND';
            case 'offline':
                return 'PRESENCE_OFFLINE';
            case 'online':
                return 'PRESENCE_ONLINE';
            default:
                break;
        }
        return 'UNKNOWN';
    }
    dialJoin(meetingInfo) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.meetingType = 'NORMAL';
            this.meetingId = (_a = meetingInfo === null || meetingInfo === void 0 ? void 0 : meetingInfo.meetingId) !== null && _a !== void 0 ? _a : this.generateMeetingId();
            this.meetingPassword = (_b = meetingInfo === null || meetingInfo === void 0 ? void 0 : meetingInfo.passcode) !== null && _b !== void 0 ? _b : this.generateMeetingPassword();
            this.realMeetingId = this.generateRealMeetingId();
            this.microphoneMute = false;
            this.cameraMute = false;
            this.layoutStyle = 'Speaker';
            this.callStatus = 'CONNECTING_MEETING';
            this.dispState = 'None';
            this.send('zCommand', 'DialJoinResult', {});
            yield this.timeouts.delay(500); // required for driver
            this.sendCallStatus(false);
            this.callStatus = 'IN_MEETING';
            this.sendCallStatus(false);
            this.sendCallInfo(false);
            this.sendMicrophoneMute(false);
            this.sendCameraMute(false);
            this.sendCallLayout(false);
            this.sendCallLayoutStyle(false);
            this.sendListParticipants(false);
            yield this.timeouts.delay(1000);
            this.addSimulatedParticipants();
        });
    }
    setSharingInstructions(dispState) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.callStatus !== 'IN_MEETING') {
                this.send('zConfiguration', 'Call', undefined, true, {
                    message: 'Result reason: "Not in meeting"',
                    state: 'Error',
                });
                return;
            }
            this.meetingType = 'SHARING_LAPTOP';
            this.dispState = dispState;
            this.isSharingBlackMagic = false;
            this.sendSharing(false);
            this.send('zCommand', 'CallSharingToggleResult', {});
        });
    }
    dialSharing(dispState) {
        return __awaiter(this, void 0, void 0, function* () {
            this.meetingType = 'SHARING_LAPTOP';
            this.meetingId = this.generateMeetingId();
            this.meetingPassword = this.generateMeetingPassword();
            this.realMeetingId = this.generateRealMeetingId();
            this.microphoneMute = true;
            this.cameraMute = true;
            this.layoutStyle = 'Speaker';
            this.callStatus = 'CONNECTING_MEETING';
            this.dispState = dispState;
            if (dispState === 'None' && this.isBlackMagicConnected) {
                this.isSharingBlackMagic = true;
            }
            this.send('zCommand', 'DialSharingResult', {});
            yield this.timeouts.delay(500); // required for driver
            this.send('zCommand', 'StartLocalPresentMeeting', { success: true }, false);
            this.sendCallStatus(false);
            this.sendCallLayout(true);
            this.sendCallLayoutStyle(false);
            this.callStatus = 'IN_MEETING';
            this.sendCallStatus(false);
            this.sendCallInfo(false);
            this.sendMicrophoneMute(false);
            this.sendCameraMute(false);
            this.sendListParticipants(false);
            this.sendSharing(false);
        });
    }
    dialStartPmi(resultTopKey = 'DialStartPmiResult') {
        return __awaiter(this, void 0, void 0, function* () {
            this.meetingType = 'NORMAL';
            this.meetingId = this.generateMeetingId();
            this.meetingPassword = this.generateMeetingPassword();
            this.realMeetingId = this.generateRealMeetingId();
            this.microphoneMute = false;
            this.cameraMute = false;
            this.layoutStyle = 'Speaker';
            this.callStatus = 'CONNECTING_MEETING';
            this.dispState = 'None';
            this.send('zCommand', resultTopKey, {});
            yield this.timeouts.delay(500); // required for driver
            this.sendCallStatus(false);
            this.sendCallLayout(true);
            this.sendCallLayoutStyle(false);
            this.callStatus = 'IN_MEETING';
            this.sendCallStatus(false);
            this.sendCallInfo(false);
            this.sendMicrophoneMute(false);
            this.sendCameraMute(false);
            this.sendListParticipants(false);
            this.sendSharing(false);
        });
    }
    findDirectoryEntry(number) {
        return this.directory.find(e => {
            for (const c of Object.values(e.contacts)) {
                if (c.number === number)
                    return true;
            }
            return false;
        });
    }
    findPeripheral(type, id) {
        return Object.values(Zoom.peripherals).find(p => {
            return p.type === type && p.id === id;
        });
    }
    formatMeetingId(meetingId, minLength = 6) {
        if (meetingId === undefined)
            return 'Meeting ID: Unknown';
        const idStr = meetingId.length > minLength
            ? [meetingId.substr(0, 3), meetingId.substr(3, 3), meetingId.substr(6)].join('-')
            : meetingId;
        return `Meeting ID: ${idStr}`;
    }
    generateMeetingId() {
        return this.generateNumericId(10).toString();
    }
    generateMeetingPassword() {
        return this.generateNumericId(6).toString();
    }
    generateNumericId(numDigits) {
        const str = Sutl.generateRandomString(1, '123456789') +
            Sutl.generateRandomString(numDigits - 1, '0123456789');
        return parseInt(str, 10);
    }
    generatePairingCode() {
        return Sutl.generateRandomString(6, '0123456789');
    }
    generateParticipantId() {
        return this.generateNumericId(6);
    }
    generateRealMeetingId() {
        return Sutl.generateRandomString(24, Zoom.realMeetingIdChars);
    }
    generateSharingKey() {
        return Sutl.generateRandomString(6, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ');
    }
    generateUserId() {
        return this.generateNumericId(8);
    }
    makeContact(entry) {
        var _a;
        for (const c of Object.values(entry.contacts)) {
            if (c.type === 'zoom') {
                return {
                    avatarURL: entry.picture,
                    firstName: entry.firstName,
                    isZoomRoom: false,
                    jid: c.number,
                    lastName: entry.lastName,
                    onDesktop: entry.onDesktop,
                    onMobile: entry.onMobile,
                    presence: this.convertPresence((_a = entry.presence) !== null && _a !== void 0 ? _a : 'unknown'),
                    screenName: entry.firstName + ' ' + entry.lastName,
                };
            }
        }
        return undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    makeResp(type, topKey, data, // eslint-disable-line @typescript-eslint/no-explicit-any
    sync = true, status = { message: '', state: 'OK' } // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resp = {
            Status: status,
            Sync: sync,
            topKey,
            type,
        };
        if (data !== undefined)
            resp[topKey] = data;
        return JSON.stringify(resp, null, 4);
    }
    makeUserName(entry) {
        if (entry.displayName !== undefined) {
            return entry.displayName;
        }
        else if (entry.firstName !== undefined) {
            if (entry.lastName !== undefined) {
                return entry.firstName + ' ' + entry.lastName;
            }
            else {
                return entry.firstName;
            }
        }
        else if (entry.lastName !== undefined) {
            return entry.lastName;
        }
        return 'Unknown';
    }
    parseNumber(str, min = 0, max = 100) {
        const value = parseInt(str, 10);
        if (Number.isNaN(value))
            return min;
        return Math.min(Math.max(value, min), max);
    }
    resetParticipants() {
        const entries = [];
        for (const id of this.participantIds) {
            const entry = this.findDirectoryEntry(id);
            if (entry === undefined)
                continue;
            entry.presence = entry.prevPresence;
            entry.cameraMute = false;
            entry.microphoneMute = false;
            entries.push(entry);
        }
        this.participantIds.length = 0;
        const interval = this.timeouts.setInterval(() => {
            const entry = entries.shift();
            if (entry === undefined) {
                interval.clear();
            }
            else {
                this.sendContact(entry);
            }
        }, 1);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    send(type, topKey, data, // eslint-disable-line @typescript-eslint/no-explicit-any
    sync = true, status = { message: '', state: 'OK' } // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        const resp = this.makeResp(type, topKey, data, sync, status);
        this.socket.send(resp);
    }
    sendCallInfo(sync = true) {
        if (this.callStatus === 'IN_MEETING') {
            this.send('zCommand', 'InfoResult', {
                Info: {
                    callin_country_list: Zoom.callInList,
                    callout_country_list: [],
                    toll_free_callin_list: [],
                },
                am_i_original_host: true,
                default_callin_country: 'US',
                dialIn: '+1 929 436 2866;+1 301 715 8592;+1 312 626 6799;+1 669 900 6833;+1 253 215 8782;+1 346 248 7799',
                international_url: 'https://us02web.zoom.us/zoomconference?tk=kNbsrDB85h5AWnlYngUBsgimkXFADRl9XxPQNyEaCyw.AB8AAAF2ezdDnwABUYAAAAAAAAAAAAAAAAAAAgAAAAABdu6O5AAAAAAAABkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA_____wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
                invite_email_content: `Join Zoom Meeting\nhttps://us02web.zoom.us/j/${this.meetingId}\n\n${this.formatMeetingId(this.meetingId)}\nOne tap mobile\n+19294362866,,${this.meetingId}# US (New York)\n+13017158592,,${this.meetingId}# US (Washington D.C)\n\nDial by your location\n        +1 929 436 2866 US (New York)\n        +1 301 715 8592 US (Washington D.C)\n        +1 312 626 6799 US (Chicago)\n        +1 669 900 6833 US (San Jose)\n        +1 253 215 8782 US (Tacoma)\n        +1 346 248 7799 US (Houston)\n${this.formatMeetingId(this.meetingId)}\nFind your local number: https://us02web.zoom.us/u/kbbXwsP4h2\n\n\n\n`,
                invite_email_subject: 'Please join Zoom meeting in progress',
                is_callin_country_list_available: true,
                is_calling_room_system_enabled: false,
                is_toll_free_callin_list_available: true,
                is_view_only: false,
                is_waiting_room: false,
                is_webinar: false,
                meeting_id: this.meetingId,
                meeting_list_item: {
                    accessRole: '',
                    calendarChangeKey: '',
                    calendarID: '',
                    checkIn: false,
                    creatorEmail: '',
                    creatorName: '',
                    endTime: '',
                    hostName: '',
                    isInstantMeeting: false,
                    isPrivate: false,
                    location: '',
                    meetingName: '',
                    meetingNumber: '',
                    scheduledFrom: 'Unknown',
                    startTime: '',
                    third_party: {
                        h323_address: '',
                        meeting_number: '',
                        service_provider: '-1',
                        sip_address: '',
                    },
                },
                meeting_password: this.meetingPassword,
                meeting_type: this.meetingType,
                my_userid: this.userId,
                participant_id: this.participantId,
                real_meeting_id: this.realMeetingId,
                schedule_option: '4503599962918144',
                schedule_option2: '288231664641908736',
                support_callout_type: 'NONE',
                toll_free_number: '',
                user_type: 'PRO',
            }, sync);
        }
        else {
            this.send('zCommand', 'CallInfoResult', undefined, sync, {
                message: 'Result reason: "Not in meeting"',
                state: 'Error',
            });
        }
    }
    sendCallLayout(sync = true) {
        const data = {
            can_Adjust_Floating_Video: true,
            can_Switch_Floating_Share_Content: false,
            can_Switch_Share_On_All_Screens: false,
            can_Switch_Speaker_View: true,
            can_Switch_Strip_View: true,
            can_Switch_Wall_View: false,
            is_In_First_Page: true,
            is_In_Last_Page: true,
            video_Count_In_Current_Page: 0,
            video_type: 'Strip',
        };
        this.send('zStatus', 'Layout', data, sync);
    }
    sendCallLayoutStyle(sync = true) {
        const data = { Call: { Layout: { Style: this.layoutStyle } } };
        this.send('zConfiguration', 'Client', data, sync);
    }
    sendCallDisconnect(sync = true) {
        this.send('zEvent', 'CallDisconnect', { success: 'on' }, sync);
    }
    sendCallStatus(sync = true) {
        this.send('zStatus', 'Call', { Status: this.callStatus }, sync);
    }
    sendCameraMute(sync = true) {
        this.send('zConfiguration', 'Call', { Camera: { Mute: this.cameraMute } }, sync);
    }
    sendCameraShare(sync = true) {
        this.send('zStatus', 'CameraShare', {
            can_ControlCamera: true,
            id: Zoom.peripherals.camera.id,
            is_Mirrored: true,
            is_Sharing: this.isSharingCamera,
            pan_Tilt_Speed: 0,
        }, sync);
    }
    sendContact(entry) {
        const contact = this.makeContact(entry);
        this.send('zEvent', 'Phonebook', { 'Updated Contact': contact }, false);
    }
    sendListParticipant(participantId, entry, sync = true) {
        let userId = this.userIds[participantId];
        if (userId === undefined) {
            userId = this.userIdMax++;
            this.userIds[participantId] = userId;
        }
        this.send('zCommand', 'ListParticipantsResult', {
            'audio_status state': entry.microphoneMute ? 'AUDIO_MUTED' : 'AUDIO_UNMUTED',
            avatar_url: entry.picture,
            event: 'ZRCUserChangedEventUserInfoUpdated',
            isCohost: false,
            is_host: false,
            is_myself: false,
            is_video_can_mute_byHost: true,
            user_id: userId,
            user_name: this.makeUserName(entry),
            'video_status is_sending': !entry.cameraMute,
        }, sync);
    }
    sendListParticipants(sync = true) {
        const participants = [];
        participants.push({
            'audio_status state': this.microphoneMute ? 'AUDIO_MUTED' : 'AUDIO_UNMUTED',
            avatar_url: this.userAvatarUrl,
            event: 'ZRCUserChangedEventJoinedMeeting',
            isCohost: false,
            is_host: true,
            is_myself: true,
            is_video_can_mute_byHost: true,
            user_id: this.userId,
            user_name: this.userName,
            'video_status is_sending': true,
        });
        for (const participantId of this.participantIds) {
            const entry = this.findDirectoryEntry(participantId);
            if (entry === undefined)
                continue;
            let userId = this.userIds[participantId];
            if (userId === undefined) {
                userId = this.userIdMax++;
                this.userIds[participantId] = userId;
            }
            participants.push({
                'audio_status state': entry.microphoneMute ? 'AUDIO_MUTED' : 'AUDIO_UNMUTED',
                avatar_url: entry.picture,
                event: 'ZRCUserChangedEventJoinedMeeting',
                isCohost: false,
                is_host: false,
                is_myself: false,
                is_video_can_mute_byHost: true,
                user_id: userId,
                user_name: this.makeUserName(entry),
                'video_status is_sending': !entry.cameraMute,
            });
        }
        this.send('zCommand', 'ListParticipantsResult', participants, sync);
    }
    sendMeetingNeedsPassword(snync = true) {
        const data = { needsPassword: true, wrongAndRetry: false };
        this.send('zEvent', 'MeetingNeedsPassword', data, false);
    }
    sendMicrophoneMute(sync = true) {
        this.send('zConfiguration', 'Call', { Microphone: { Mute: this.microphoneMute } }, sync);
    }
    sendSharing(sync = true) {
        this.send('zStatus', 'Sharing', {
            directPresentationPairingCode: this.directPresentationPairingCode,
            directPresentationSharingKey: this.directPresentationSharingKey,
            dispState: this.dispState,
            isAirHostClientConnected: false,
            isBlackMagicConnected: this.isBlackMagicConnected,
            isBlackMagicDataAvailable: this.isBlackMagicConnected,
            isDirectPresentationConnected: this.isSharingBlackMagic,
            isSharingBlackMagic: this.isSharingBlackMagic,
            password: '123456789',
            serverName: this.userName,
            wifiName: 'Aveo Systems',
        }, sync);
    }
}
Zoom.emulatorType = 'socketEmulator';
Zoom.key = '-LDmH6a8aVJTYIXyiiQ9';
Zoom.callInList = [
    {
        code: 54,
        display_number: '+54 343 414 5986',
        id: 'AR',
        name: 'Argentina',
        number: '+54 3434145986',
    },
    {
        code: 54,
        display_number: '+54 341 512 2188',
        id: 'AR',
        name: 'Argentina',
        number: '+54 3415122188',
    },
    {
        code: 54,
        display_number: '+54 115 983 6950',
        id: 'AR',
        name: 'Argentina',
        number: '+54 1159836950',
    },
    {
        code: 54,
        display_number: '+54 112 040 0447',
        id: 'AR',
        name: 'Argentina',
        number: '+54 1120400447',
    },
    {
        code: 61,
        display_number: '+61 7 3185 3730',
        id: 'AU',
        name: 'Australia',
        number: '+61 731853730',
    },
    {
        code: 61,
        display_number: '+61 3 7018 2005',
        id: 'AU',
        name: 'Australia',
        number: '+61 370182005',
    },
    {
        code: 61,
        display_number: '+61 2 8015 6011',
        id: 'AU',
        name: 'Australia',
        number: '+61 280156011',
    },
    {
        code: 61,
        display_number: '+61 8 7150 1149',
        id: 'AU',
        name: 'Australia',
        number: '+61 871501149',
    },
    {
        code: 61,
        display_number: '+61 8 6119 3900',
        id: 'AU',
        name: 'Australia',
        number: '+61 861193900',
    },
    {
        code: 43,
        display_number: '+43 12 535 502',
        id: 'AT',
        name: 'Austria',
        number: '+43 12535502',
    },
    {
        code: 43,
        display_number: '+43 120 609 3072',
        id: 'AT',
        name: 'Austria',
        number: '+43 1206093072',
    },
    {
        code: 43,
        display_number: '+43 12 535 501',
        id: 'AT',
        name: 'Austria',
        number: '+43 12535501',
    },
    {
        code: 43,
        display_number: '+43 72 011 5988',
        id: 'AT',
        name: 'Austria',
        number: '+43 720115988',
    },
    {
        code: 43,
        display_number: '+43 670 309 0165',
        id: 'AT',
        name: 'Austria',
        number: '+43 6703090165',
    },
    {
        code: 973,
        display_number: '+973 1619 8488',
        id: 'BH',
        name: 'Bahrain',
        number: '+973 16198488',
    },
    {
        code: 973,
        display_number: '+973 1619 7601',
        id: 'BH',
        name: 'Bahrain',
        number: '+973 16197601',
    },
    {
        code: 32,
        display_number: '+32 2 585 5574',
        id: 'BE',
        name: 'Belgium',
        number: '+32 25855574',
    },
    {
        code: 32,
        display_number: '+32 2 588 4188',
        id: 'BE',
        name: 'Belgium',
        number: '+32 25884188',
    },
    {
        code: 32,
        display_number: '+32 2 788 0172',
        id: 'BE',
        name: 'Belgium',
        number: '+32 27880172',
    },
    {
        code: 32,
        display_number: '+32 2 788 0173',
        id: 'BE',
        name: 'Belgium',
        number: '+32 27880173',
    },
    {
        code: 32,
        display_number: '+32 1579 5132',
        id: 'BE',
        name: 'Belgium',
        number: '+32 15795132',
    },
    {
        code: 32,
        display_number: '+32 2 290 9360',
        id: 'BE',
        name: 'Belgium',
        number: '+32 22909360',
    },
    {
        code: 55,
        display_number: '+55 11 4700 9668',
        id: 'BR',
        name: 'Brazil',
        number: '+55 1147009668',
    },
    {
        code: 55,
        display_number: '+55 21 3958 7888',
        id: 'BR',
        name: 'Brazil',
        number: '+55 2139587888',
    },
    {
        code: 55,
        display_number: '+55 11 4632 2236',
        id: 'BR',
        name: 'Brazil',
        number: '+55 1146322236',
    },
    {
        code: 55,
        display_number: '+55 11 4632 2237',
        id: 'BR',
        name: 'Brazil',
        number: '+55 1146322237',
    },
    {
        code: 55,
        display_number: '+55 11 4680 6788',
        id: 'BR',
        name: 'Brazil',
        number: '+55 1146806788',
    },
    {
        code: 359,
        display_number: '+359 2 492 5688',
        id: 'BG',
        name: 'Bulgaria',
        number: '+359 24925688',
    },
    {
        code: 359,
        display_number: '+359 3 257 1633',
        id: 'BG',
        name: 'Bulgaria',
        number: '+359 32571633',
    },
    {
        code: 1,
        display_number: '+1 647 558 0588',
        id: 'CA',
        name: 'Canada',
        number: '+1 6475580588',
    },
    {
        code: 1,
        display_number: '+1 778 907 2071',
        id: 'CA',
        name: 'Canada',
        number: '+1 7789072071',
    },
    {
        code: 1,
        display_number: '+1 438 809 7799',
        id: 'CA',
        name: 'Canada',
        number: '+1 4388097799',
    },
    {
        code: 1,
        display_number: '+1 204 272 7920',
        id: 'CA',
        name: 'Canada',
        number: '+1 2042727920',
    },
    {
        code: 1,
        display_number: '+1 587 328 1099',
        id: 'CA',
        name: 'Canada',
        number: '+1 5873281099',
    },
    {
        code: 1,
        display_number: '+1 647 374 4685',
        id: 'CA',
        name: 'Canada',
        number: '+1 6473744685',
    },
    {
        code: 56,
        display_number: '+56 22 573 9305',
        id: 'CL',
        name: 'Chile',
        number: '+56 225739305',
    },
    {
        code: 56,
        display_number: '+56 23 210 9066',
        id: 'CL',
        name: 'Chile',
        number: '+56 232109066',
    },
    {
        code: 56,
        display_number: '+56 41 256 0288',
        id: 'CL',
        name: 'Chile',
        number: '+56 412560288',
    },
    {
        code: 56,
        display_number: '+56 22 573 9304',
        id: 'CL',
        name: 'Chile',
        number: '+56 225739304',
    },
    {
        code: 56,
        display_number: '+56 232 938 848',
        id: 'CL',
        name: 'Chile',
        number: '+56 232938848',
    },
    {
        code: 57,
        display_number: '+57 2 620 7388',
        id: 'CO',
        name: 'Colombia',
        number: '+57 26207388',
    },
    {
        code: 57,
        display_number: '+57 1 508 7702',
        id: 'CO',
        name: 'Colombia',
        number: '+57 15087702',
    },
    {
        code: 57,
        display_number: '+57 1 514 0382',
        id: 'CO',
        name: 'Colombia',
        number: '+57 15140382',
    },
    {
        code: 57,
        display_number: '+57 1 518 9697',
        id: 'CO',
        name: 'Colombia',
        number: '+57 15189697',
    },
    {
        code: 57,
        display_number: '+57 1 518 9698',
        id: 'CO',
        name: 'Colombia',
        number: '+57 15189698',
    },
    {
        code: 506,
        display_number: '+506 4100 7699',
        id: 'CR',
        name: 'Costa Rica',
        number: '+506 41007699',
    },
    {
        code: 385,
        display_number: '+385 1777 6333',
        id: 'HR',
        name: 'Croatia',
        number: '+385 17776333',
    },
    {
        code: 385,
        display_number: '+385 1300 0988',
        id: 'HR',
        name: 'Croatia',
        number: '+385 13000988',
    },
    {
        code: 357,
        display_number: '+357 2 200 0888',
        id: 'CY',
        name: 'Cyprus',
        number: '+357 22000888',
    },
    {
        code: 357,
        display_number: '+357 2 505 4777',
        id: 'CY',
        name: 'Cyprus',
        number: '+357 25054777',
    },
    {
        code: 420,
        display_number: '+420 2 2888 2388',
        id: 'CZ',
        name: 'Czechia',
        number: '+420 228882388',
    },
    {
        code: 420,
        display_number: '+420 5 3889 0161',
        id: 'CZ',
        name: 'Czechia',
        number: '+420 538890161',
    },
    {
        code: 420,
        display_number: '+420 2 3901 8272',
        id: 'CZ',
        name: 'Czechia',
        number: '+420 239018272',
    },
    {
        code: 45,
        display_number: '+45 89 88 37 88',
        id: 'DK',
        name: 'Denmark',
        number: '+45 89883788',
    },
    {
        code: 45,
        display_number: '+45 47 37 25 75',
        id: 'DK',
        name: 'Denmark',
        number: '+45 47372575',
    },
    {
        code: 45,
        display_number: '+45 32 72 80 11',
        id: 'DK',
        name: 'Denmark',
        number: '+45 32728011',
    },
    {
        code: 45,
        display_number: '+45 32 72 80 10',
        id: 'DK',
        name: 'Denmark',
        number: '+45 32728010',
    },
    {
        code: 45,
        display_number: '+45 32 71 31 57',
        id: 'DK',
        name: 'Denmark',
        number: '+45 32713157',
    },
    {
        code: 45,
        display_number: '+45 32 70 12 06',
        id: 'DK',
        name: 'Denmark',
        number: '+45 32701206',
    },
    {
        code: 1,
        display_number: '+1 829 956 2188',
        id: 'DO',
        name: 'Dominican Republic',
        number: '+1 8299562188',
    },
    {
        code: 1,
        display_number: '+1 829 947 9220',
        id: 'DO',
        name: 'Dominican Republic',
        number: '+1 8299479220',
    },
    {
        code: 593,
        display_number: '+593 962 842 117',
        id: 'EC',
        name: 'Ecuador',
        number: '+593 962842117',
    },
    {
        code: 503,
        display_number: '+503 2136 6444',
        id: 'SV',
        name: 'El Salvador',
        number: '+503 21366444',
    },
    {
        code: 503,
        display_number: '+503 2113 9088',
        id: 'SV',
        name: 'El Salvador',
        number: '+503 21139088',
    },
    {
        code: 372,
        display_number: '+372 660 1699',
        id: 'EE',
        name: 'Estonia',
        number: '+372 6601699',
    },
    {
        code: 372,
        display_number: '+372 880 1188',
        id: 'EE',
        name: 'Estonia',
        number: '+372 8801188',
    },
    {
        code: 358,
        display_number: '+358 9 4245 1488',
        id: 'FI',
        name: 'Finland',
        number: '+358 942451488',
    },
    {
        code: 358,
        display_number: '+358 9 7252 2471',
        id: 'FI',
        name: 'Finland',
        number: '+358 972522471',
    },
    {
        code: 358,
        display_number: '+358 3 4109 2129',
        id: 'FI',
        name: 'Finland',
        number: '+358 341092129',
    },
    {
        code: 33,
        display_number: '+33 1 7037 9729',
        id: 'FR',
        name: 'France',
        number: '+33 170379729',
    },
    {
        code: 33,
        display_number: '+33 1 7037 2246',
        id: 'FR',
        name: 'France',
        number: '+33 170372246',
    },
    {
        code: 33,
        display_number: '+33 1 8699 5831',
        id: 'FR',
        name: 'France',
        number: '+33 186995831',
    },
    {
        code: 33,
        display_number: '+33 1 7095 0350',
        id: 'FR',
        name: 'France',
        number: '+33 170950350',
    },
    {
        code: 33,
        display_number: '+33 1 7095 0103',
        id: 'FR',
        name: 'France',
        number: '+33 170950103',
    },
    {
        code: 995,
        display_number: '+995 7067 77954',
        id: 'GE',
        name: 'Georgia',
        number: '+995 706777954',
    },
    {
        code: 995,
        display_number: '+995 3224 73988',
        id: 'GE',
        name: 'Georgia',
        number: '+995 322473988',
    },
    {
        code: 49,
        display_number: '+49 69 7104 9922',
        id: 'DE',
        name: 'Germany',
        number: '+49 6971049922',
    },
    {
        code: 49,
        display_number: '+49 695 050 2596',
        id: 'DE',
        name: 'Germany',
        number: '+49 6950502596',
    },
    {
        code: 49,
        display_number: '+49 69 3807 9883',
        id: 'DE',
        name: 'Germany',
        number: '+49 6938079883',
    },
    {
        code: 49,
        display_number: '+49 30 5679 5800',
        id: 'DE',
        name: 'Germany',
        number: '+49 3056795800',
    },
    {
        code: 30,
        display_number: '+30 211 198 4488',
        id: 'GR',
        name: 'Greece',
        number: '+30 2111984488',
    },
    {
        code: 30,
        display_number: '+30 231 118 0599',
        id: 'GR',
        name: 'Greece',
        number: '+30 2311180599',
    },
    {
        code: 36,
        display_number: '+36 1 701 0488',
        id: 'HU',
        name: 'Hungary',
        number: '+36 17010488',
    },
    {
        code: 36,
        display_number: '+36 1 408 8456',
        id: 'HU',
        name: 'Hungary',
        number: '+36 14088456',
    },
    {
        code: 36,
        display_number: '+36 1 779 9126',
        id: 'HU',
        name: 'Hungary',
        number: '+36 17799126',
    },
    {
        code: 353,
        display_number: '+353 1 653 3898',
        id: 'IE',
        name: 'Ireland',
        number: '+353 16533898',
    },
    {
        code: 353,
        display_number: '+353 6 163 9031',
        id: 'IE',
        name: 'Ireland',
        number: '+353 61639031',
    },
    {
        code: 353,
        display_number: '+353 1 240 8941',
        id: 'IE',
        name: 'Ireland',
        number: '+353 12408941',
    },
    {
        code: 353,
        display_number: '+353 1 536 9320',
        id: 'IE',
        name: 'Ireland',
        number: '+353 15369320',
    },
    {
        code: 353,
        display_number: '+353 1 653 3895',
        id: 'IE',
        name: 'Ireland',
        number: '+353 16533895',
    },
    {
        code: 353,
        display_number: '+353 1 653 3897',
        id: 'IE',
        name: 'Ireland',
        number: '+353 16533897',
    },
    {
        code: 972,
        display_number: '+972 55 330 1762',
        id: 'IL',
        name: 'Israel',
        number: '+972 553301762',
    },
    {
        code: 972,
        display_number: '+972 3 978 6688',
        id: 'IL',
        name: 'Israel',
        number: '+972 39786688',
    },
    {
        code: 39,
        display_number: '+39 021 241 28 823',
        id: 'IT',
        name: 'Italy',
        number: '+39 02124128823',
    },
    {
        code: 39,
        display_number: '+39 069 480 6488',
        id: 'IT',
        name: 'Italy',
        number: '+39 0694806488',
    },
    {
        code: 39,
        display_number: '+39 020 066 7245',
        id: 'IT',
        name: 'Italy',
        number: '+39 0200667245',
    },
    {
        code: 81,
        display_number: '+81 524 564 439',
        id: 'JP',
        name: 'Japan',
        number: '+81 524564439',
    },
    {
        code: 81,
        display_number: '+81 363 628 317',
        id: 'JP',
        name: 'Japan',
        number: '+81 363628317',
    },
    {
        code: 81,
        display_number: '+81 3 4578 1488',
        id: 'JP',
        name: 'Japan',
        number: '+81 345781488',
    },
    {
        code: 82,
        display_number: '+82 2 6105 4111',
        id: 'KR',
        name: 'Korea, Republic of',
        number: '+82 261054111',
    },
    {
        code: 82,
        display_number: '+82 2 6022 2322',
        id: 'KR',
        name: 'Korea, Republic of',
        number: '+82 260222322',
    },
    {
        code: 371,
        display_number: '+371 6303 1808',
        id: 'LV',
        name: 'Latvia',
        number: '+371 63031808',
    },
    {
        code: 371,
        display_number: '+371 6303 1888',
        id: 'LV',
        name: 'Latvia',
        number: '+371 63031888',
    },
    {
        code: 370,
        display_number: '+370 5214 1488',
        id: 'LT',
        name: 'Lithuania',
        number: '+370 52141488',
    },
    {
        code: 370,
        display_number: '+370 3799 9260',
        id: 'LT',
        name: 'Lithuania',
        number: '+370 37999260',
    },
    {
        code: 352,
        display_number: '+352 2786 4277',
        id: 'LU',
        name: 'Luxembourg',
        number: '+352 27864277',
    },
    {
        code: 352,
        display_number: '+352 342 080 9265',
        id: 'LU',
        name: 'Luxembourg',
        number: '+352 3420809265',
    },
    {
        code: 352,
        display_number: '+352 2786 1188',
        id: 'LU',
        name: 'Luxembourg',
        number: '+352 27861188',
    },
    {
        code: 60,
        display_number: '+60 3 3099 2229',
        id: 'MY',
        name: 'Malaysia',
        number: '+60 330992229',
    },
    {
        code: 60,
        display_number: '+60 3 7724 4079',
        id: 'MY',
        name: 'Malaysia',
        number: '+60 377244079',
    },
    {
        code: 60,
        display_number: '+60 3 9212 1727',
        id: 'MY',
        name: 'Malaysia',
        number: '+60 392121727',
    },
    {
        code: 60,
        display_number: '+60 3 7724 4080',
        id: 'MY',
        name: 'Malaysia',
        number: '+60 377244080',
    },
    {
        code: 356,
        display_number: '+356 2778 1288',
        id: 'MT',
        name: 'Malta',
        number: '+356 27781288',
    },
    {
        code: 356,
        display_number: '+356 2776 1777',
        id: 'MT',
        name: 'Malta',
        number: '+356 27761777',
    },
    {
        code: 52,
        display_number: '+52 556 826 9800',
        id: 'MX',
        name: 'Mexico',
        number: '+52 5568269800',
    },
    {
        code: 52,
        display_number: '+52 229 910 0061',
        id: 'MX',
        name: 'Mexico',
        number: '+52 2299100061',
    },
    {
        code: 52,
        display_number: '+52 554 161 4288',
        id: 'MX',
        name: 'Mexico',
        number: '+52 5541614288',
    },
    {
        code: 52,
        display_number: '+52 558 659 6001',
        id: 'MX',
        name: 'Mexico',
        number: '+52 5586596001',
    },
    {
        code: 31,
        display_number: '+31 20 794 6520',
        id: 'NL',
        name: 'Netherlands',
        number: '+31 207946520',
    },
    {
        code: 31,
        display_number: '+31 20 794 7345',
        id: 'NL',
        name: 'Netherlands',
        number: '+31 207947345',
    },
    {
        code: 31,
        display_number: '+31 20 794 0854',
        id: 'NL',
        name: 'Netherlands',
        number: '+31 207940854',
    },
    {
        code: 31,
        display_number: '+31 20 241 0288',
        id: 'NL',
        name: 'Netherlands',
        number: '+31 202410288',
    },
    {
        code: 31,
        display_number: '+31 20 794 6519',
        id: 'NL',
        name: 'Netherlands',
        number: '+31 207946519',
    },
    {
        code: 64,
        display_number: '+64 3 659 0603',
        id: 'NZ',
        name: 'New Zealand',
        number: '+64 36590603',
    },
    {
        code: 64,
        display_number: '+64 9 884 6780',
        id: 'NZ',
        name: 'New Zealand',
        number: '+64 98846780',
    },
    {
        code: 64,
        display_number: '+64 4 886 0026',
        id: 'NZ',
        name: 'New Zealand',
        number: '+64 48860026',
    },
    {
        code: 47,
        display_number: '+47 7349 4877',
        id: 'NO',
        name: 'Norway',
        number: '+47 73494877',
    },
    {
        code: 47,
        display_number: '+47 2400 4735',
        id: 'NO',
        name: 'Norway',
        number: '+47 24004735',
    },
    {
        code: 47,
        display_number: '+47 2396 0588',
        id: 'NO',
        name: 'Norway',
        number: '+47 23960588',
    },
    {
        code: 507,
        display_number: '+507 378 2155',
        id: 'PA',
        name: 'Panama',
        number: '+507 3782155',
    },
    {
        code: 507,
        display_number: '+507 833 9588',
        id: 'PA',
        name: 'Panama',
        number: '+507 8339588',
    },
    {
        code: 51,
        display_number: '+51 1 708 8312',
        id: 'PE',
        name: 'Peru',
        number: '+51 17088312',
    },
    {
        code: 51,
        display_number: '+51 1 730 6777',
        id: 'PE',
        name: 'Peru',
        number: '+51 17306777',
    },
    {
        code: 51,
        display_number: '+51 1 707 5788',
        id: 'PE',
        name: 'Peru',
        number: '+51 17075788',
    },
    {
        code: 48,
        display_number: '+48 22 307 3488',
        id: 'PL',
        name: 'Poland',
        number: '+48 223073488',
    },
    {
        code: 48,
        display_number: '+48 22 398 7356',
        id: 'PL',
        name: 'Poland',
        number: '+48 223987356',
    },
    {
        code: 48,
        display_number: '+48 22 306 5342',
        id: 'PL',
        name: 'Poland',
        number: '+48 223065342',
    },
    {
        code: 351,
        display_number: '+351 211 202 618',
        id: 'PT',
        name: 'Portugal',
        number: '+351 211202618',
    },
    {
        code: 351,
        display_number: '+351 308 810 988',
        id: 'PT',
        name: 'Portugal',
        number: '+351 308810988',
    },
    {
        code: 351,
        display_number: '+351 308 804 188',
        id: 'PT',
        name: 'Portugal',
        number: '+351 308804188',
    },
    {
        code: 1,
        display_number: '+1 939 945 0244',
        id: 'PR',
        name: 'Puerto Rico',
        number: '+1 9399450244',
    },
    {
        code: 1,
        display_number: '+1 787 945 1488',
        id: 'PR',
        name: 'Puerto Rico',
        number: '+1 7879451488',
    },
    {
        code: 1,
        display_number: '+1 787 966 7727',
        id: 'PR',
        name: 'Puerto Rico',
        number: '+1 7879667727',
    },
    {
        code: 40,
        display_number: '+40 37 170 0418',
        id: 'RO',
        name: 'Romania',
        number: '+40 371700418',
    },
    {
        code: 40,
        display_number: '+40 31 630 1088',
        id: 'RO',
        name: 'Romania',
        number: '+40 316301088',
    },
    {
        code: 7,
        display_number: '+7 495 283 9788',
        id: 'RU',
        name: 'Russian Federation',
        number: '+7 4952839788',
    },
    {
        code: 7,
        display_number: '+7 499 951 6379',
        id: 'RU',
        name: 'Russian Federation',
        number: '+7 4999516379',
    },
    {
        code: 7,
        display_number: '+7 812 426 8988',
        id: 'RU',
        name: 'Russian Federation',
        number: '+7 8124268988',
    },
    {
        code: 7,
        display_number: '+7 499 951 6380',
        id: 'RU',
        name: 'Russian Federation',
        number: '+7 4999516380',
    },
    {
        code: 65,
        display_number: '+65 3165 1065',
        id: 'SG',
        name: 'Singapore',
        number: '+65 31651065',
    },
    {
        code: 65,
        display_number: '+65 3158 7288',
        id: 'SG',
        name: 'Singapore',
        number: '+65 31587288',
    },
    {
        code: 421,
        display_number: '+421 233 418 515',
        id: 'SK',
        name: 'Slovakia',
        number: '+421 233418515',
    },
    {
        code: 421,
        display_number: '+421 233 056 888',
        id: 'SK',
        name: 'Slovakia',
        number: '+421 233056888',
    },
    {
        code: 386,
        display_number: '+386 1888 8788',
        id: 'SI',
        name: 'Slovenia',
        number: '+386 18888788',
    },
    {
        code: 386,
        display_number: '+386 1600 3102',
        id: 'SI',
        name: 'Slovenia',
        number: '+386 16003102',
    },
    {
        code: 27,
        display_number: '+27 87 550 3946',
        id: 'ZA',
        name: 'South Africa',
        number: '+27 875503946',
    },
    {
        code: 27,
        display_number: '+27 21 426 8191',
        id: 'ZA',
        name: 'South Africa',
        number: '+27 214268191',
    },
    {
        code: 27,
        display_number: '+27 21 426 8190',
        id: 'ZA',
        name: 'South Africa',
        number: '+27 214268190',
    },
    {
        code: 27,
        display_number: '+27 87 551 7702',
        id: 'ZA',
        name: 'South Africa',
        number: '+27 875517702',
    },
    {
        code: 34,
        display_number: '+34 917 873 431',
        id: 'ES',
        name: 'Spain',
        number: '+34 917873431',
    },
    {
        code: 34,
        display_number: '+34 84 368 5025',
        id: 'ES',
        name: 'Spain',
        number: '+34 843685025',
    },
    {
        code: 34,
        display_number: '+34 91 787 0058',
        id: 'ES',
        name: 'Spain',
        number: '+34 917870058',
    },
    {
        code: 46,
        display_number: '+46 8 5050 0828',
        id: 'SE',
        name: 'Sweden',
        number: '+46 850500828',
    },
    {
        code: 46,
        display_number: '+46 850 539 728',
        id: 'SE',
        name: 'Sweden',
        number: '+46 850539728',
    },
    {
        code: 46,
        display_number: '+46 8 5052 0017',
        id: 'SE',
        name: 'Sweden',
        number: '+46 850520017',
    },
    {
        code: 46,
        display_number: '+46 8 5050 0829',
        id: 'SE',
        name: 'Sweden',
        number: '+46 850500829',
    },
    {
        code: 46,
        display_number: '+46 8 5016 3827',
        id: 'SE',
        name: 'Sweden',
        number: '+46 850163827',
    },
    {
        code: 46,
        display_number: '+46 8 4468 2488',
        id: 'SE',
        name: 'Sweden',
        number: '+46 844682488',
    },
    {
        code: 41,
        display_number: '+41 31 528 09 88',
        id: 'CH',
        name: 'Switzerland',
        number: '+41 315280988',
    },
    {
        code: 41,
        display_number: '+41 22 591 01 56',
        id: 'CH',
        name: 'Switzerland',
        number: '+41 225910156',
    },
    {
        code: 41,
        display_number: '+41 22 591 00 05',
        id: 'CH',
        name: 'Switzerland',
        number: '+41 225910005',
    },
    {
        code: 41,
        display_number: '+41 43 210 71 08',
        id: 'CH',
        name: 'Switzerland',
        number: '+41 432107108',
    },
    {
        code: 41,
        display_number: '+41 43 210 70 42',
        id: 'CH',
        name: 'Switzerland',
        number: '+41 432107042',
    },
    {
        code: 41,
        display_number: '+41 44 529 92 72',
        id: 'CH',
        name: 'Switzerland',
        number: '+41 445299272',
    },
    {
        code: 90,
        display_number: '+90 216 900 2606',
        id: 'TR',
        name: 'Turkey',
        number: '+90 2169002606',
    },
    {
        code: 90,
        display_number: '+90 216 900 1866',
        id: 'TR',
        name: 'Turkey',
        number: '+90 2169001866',
    },
    {
        code: 44,
        display_number: '+44 131 460 1196',
        id: 'GB',
        name: 'United Kingdom',
        number: '+44 1314601196',
    },
    {
        code: 44,
        display_number: '+44 203 901 7895',
        id: 'GB',
        name: 'United Kingdom',
        number: '+44 2039017895',
    },
    {
        code: 44,
        display_number: '+44 203 481 5240',
        id: 'GB',
        name: 'United Kingdom',
        number: '+44 2034815240',
    },
    {
        code: 44,
        display_number: '+44 203 481 5237',
        id: 'GB',
        name: 'United Kingdom',
        number: '+44 2034815237',
    },
    {
        code: 44,
        display_number: '+44 203 051 2874',
        id: 'GB',
        name: 'United Kingdom',
        number: '+44 2030512874',
    },
    {
        code: 1,
        display_number: '+1 346 248 7799',
        id: 'US',
        name: 'United States of America',
        number: '+1 3462487799',
    },
    {
        code: 1,
        display_number: '+1 253 215 8782',
        id: 'US',
        name: 'United States of America',
        number: '+1 2532158782',
    },
    {
        code: 1,
        display_number: '+1 669 900 6833',
        id: 'US',
        name: 'United States of America',
        number: '+1 6699006833',
    },
    {
        code: 1,
        display_number: '+1 312 626 6799',
        id: 'US',
        name: 'United States of America',
        number: '+1 3126266799',
    },
    {
        code: 1,
        display_number: '+1 929 436 2866',
        id: 'US',
        name: 'United States of America',
        number: '+1 9294362866',
    },
    {
        code: 1,
        display_number: '+1 301 715 8592',
        id: 'US',
        name: 'United States of America',
        number: '+1 3017158592',
    },
];
Zoom.peripherals = {
    camera: {
        alias: 'usb:03b4:02f9',
        name: 'HuddleCamHD',
        id: '\\\\?\\usb#vid_03b4&pid_02f9&mi_00#6&2e0efea1&0&0000#{65e8773d-8f56-11d0-a3b9-00a0c9223196}\\global',
        type: 'camera',
    },
    hdmi: {
        alias: 'usb:2935:0006',
        name: 'USB Capture HDMI',
        id: '\\\\?\\usb#vid_2935&pid_0006&mi_00#6&35e86111&0&0000#{65e8773d-8f56-11d0-a3b9-00a0c9223196}\\global',
        type: 'camera',
    },
    lineIn: {
        alias: '',
        id: '{0.0.1.00000000}.{4f908a01-9fe8-4916-8acb-88036a86665a}',
        name: 'Line In (Realtek(R) Audio)',
        type: 'lineIn',
    },
    lineOut: {
        alias: '',
        id: '{0.0.0.00000000}.{d15120fa-4b9f-462d-ba76-64417823d617}',
        name: 'MATRIX 4*4 (Intel(R) Display Audio)',
        type: 'lineOut',
    },
    usbLineIn: {
        alias: '',
        id: '11223344',
        name: 'USB Adapter Line In',
        type: 'lineIn',
    },
    usbLineOut: {
        alias: '',
        id: '22334455',
        name: 'USB Adapter Line Out',
        type: 'lineOut',
    },
};
Zoom.realMeetingIdChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz=';
